/**
 * @type {FarmcamSim}
 */
export const fcsPlaceholder = {
	Imsi: "",
	Active: false,
	RemainingData: 0,
	MonthlyData: 0,
	DataUsage: [],
	TrialUsed: false,
	LowDataWarning: false,
	Metadata: {
		OwnerEmail: "",
		Name: "",
		Tags: [],
		Access: [],
		Notify: [],
	},
	Subscription: {
		ExpiresAt: "",
		PriceIds: {
			Current: "",
			Next: "",
		},
		Trialing: false,
	},
};
